import { createContext } from "react";
import { DEFAULT_USER } from "../utils/Constants";
import { AppContextType } from "../utils/Interfaces";

const AppContext = createContext<AppContextType>({
  reports: [],
  setReports: () => null,
  firebaseUserLogInInfo: null,
  setFirebaseUserLogInInfo: () => null,
  currentUser: DEFAULT_USER,
  setCurrentUser: () => null,
  jwt: "",
  setJWT: () => null,
  userToEdit: DEFAULT_USER,
  setUserToEdit: () => null,
  selectedLocationCluster: null,
  setSelectedLocationCluster: () => null,
});

export default AppContext;
